<template>
  <div class="navTop">
    <div class="navl" @click="toShort">
      <img class="logo" :src="$utils.getPng('icon-short-logop')" />
      <img class="title" :src="$utils.getPng('icon-short-pcn')" />
    </div>
    <div class="navr">
      <div
        class="dropDownBox"
        @mouseenter="showDropFun()"
        @mouseleave="showDropFun()"
      >
        <div class="titBox">
          <svg-btn class="icon" icon-class="icon-top-lang"></svg-btn>
        </div>
        <div class="user2"></div>
        <div class="dropItem">
          <div class="one pointer" @click="changeLang('en')">
            <div class="ontit">English</div>
          </div>
          <div class="one one2 pointer" @click="changeLang('zh')">
            <div class="ontit">简体中文</div>
          </div>
          <div class="one one2 pointer" @click="changeLang('hk')">
            <div class="ontit">繁體中文</div>
          </div>
        </div>
      </div>
      <div class="general" v-if="$store.state.isLogin == 1">
        <HoverPop>
          <div class="genBox">
            <!-- <el-badge
              style="height: 20px"
              :max="99"
              :value="$store.state.userMsgNub"
              :hidden="$store.state.userMsgNub == 0"
            >
              <svg-btn class="logo1" icon-class="icon-general"></svg-btn>
            </el-badge> -->
            <svg-btn class="logo1" icon-class="icon-general3"></svg-btn>
          </div>
          <div slot="content">
            <userNews
              :isShow="true"
              @handleClose="isShowuserNews = false"
            ></userNews>
          </div>
        </HoverPop>
      </div>
      <!-- 请尽快设置密码，避免盗号风险！ -->
      <div
        class="fuliBox"
        v-if="$store.state.isLogin == 1 && $store.state.userInfo.is_pass == 0"
      >
        <div class="needSetPswVisible">
          <!-- <div class="line"></div> -->
          <div
            class="set-psw-box"
            @click="handleClickPsw"
            :style="`backgroundImage:url(${
              $store.state.theme == 'light'
                ? $utils.getPng('set-password')
                : $utils.getPng('web4/icon-equir-n')
            })`"
          >
            <div class="set-psw-img">
              <img :src="$utils.getPng('set-password-icon')" alt="" />
            </div>
            <div class="set-psw-text">
              <RaceNotice msg="请尽快设置密码，避免盗号风险！"></RaceNotice>
            </div>
          </div>
        </div>
      </div>
      <div
        class="userBoxNew"
        v-if="$store.state.isLogin == 1"
        :style="{
          backgroundImage: `url(${$utils.getPng(haveBg)})`,
        }"
      >
        <div class="openLeft" @click="openVip()">
          <HoverPop>
            <div class="left">
              <img
                class="logoOpen"
                :src="$utils.getPng('icon-vip-newTb-new')"
              />
              <span class="fontOne">{{
                upgrade_type === 0
                  ? $t('home.Premium')
                  : upgrade_type === 1
                  ? $t('home.PremiumTwo')
                  : $t('home.PremiumThree')
              }}</span>
            </div>
            <div
              slot="content"
              class="vipHoverBox3"
              :class="upgrade_type === 2 ? 'vipHoverBox4' : ''"
              @click="openVip()"
            >
              <img
                :class="upgrade_type === 2 ? 'topBoxVip2' : 'topBoxVip'"
                :src="
                  upgrade_type === 0
                    ? $utils.getPng('icon-vip-bgTwo-new')
                    : upgrade_type === 1
                    ? $utils.getPng('icon-vip-bgOne-new')
                    : $utils.getPng('icon-vip-bgThree-new')
                "
              />
              <div class="btBoxVip">
                <div
                  class="fontLine"
                  v-html="
                    $utils.getSearchKeyword(
                      upgrade_obj?.text,
                      upgrade_obj?.text_spec,
                      '#AB4B01'
                    )
                  "
                ></div>
                <div class="qlVipBox" v-if="this.upgrade_info.length > 0">
                  <div
                    class="qlBox"
                    v-for="(item, index) in upgrade_info"
                    :key="index"
                  >
                    <img class="qlIcon" :src="item.icons" alt="" />
                    <div class="qlRight">
                      <span class="titVip">{{ item.title }}</span>
                      <span class="textVip">{{ item.text }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="btNew"
                  v-if="upgrade_type !== 2"
                  @click="openVip()"
                  :style="{
                    backgroundImage: `url(${$utils.getPng(
                      'icon-vip-btNew-new'
                    )})`,
                  }"
                >
                  <span
                    >{{ upgrade_type == 0 ? '开通' : '升级'
                    }}{{ upgrade_obj?.title }}</span
                  >
                </div>
              </div>
            </div>
          </HoverPop>
          <div class="lineOpen"></div>
        </div>
        <HoverPop>
          <div class="openRight" @mouseenter="getWebUserVipInfoFn">
            <div class="right">
              <div class="fontTwo" v-if="VipInfo?.cloud_size?.self_size">
                {{ VipInfo?.cloud_size?.self_size }}G /
                <span
                  style="margin-left: 2px"
                  :class="{
                    endless: VipInfo?.cloud_size?.cloud_size == '999999',
                  }"
                >
                  {{
                    VipInfo?.cloud_size?.cloud_size == '999999'
                      ? '∞'
                      : VipInfo?.cloud_size?.cloud_size + 'G'
                  }}</span
                >
                <svg-btn
                  v-if="VipInfo?.cloud_size?.is_rate_flow == 1"
                  class="star"
                  icon-class="icon-Spacelevel"
                ></svg-btn>
                <!-- <el-tooltip placement="bottom-end">
              <template #content>
                <div class="tooltip-openNew">
                  <div class="tooltip-item" v-for="(item,index) in openList" :key="index">{{item}}</div>
                </div>
              </template>
              <svg-btn class="star" icon-class="icon-Spacelevel"></svg-btn>
            </el-tooltip> -->
              </div>
              <div class="nofont" v-else></div>
              <el-progress
                :percentage="usedPre > 100 ? 100 : usedPre"
                :stroke-width="4"
                :text-inside="true"
              ></el-progress>
            </div>
            <div style="height: 22px">
              <img class="picture" :src="$store.state.userInfo.logo" alt="" />
            </div>
          </div>
          <div slot="content" class="userOperateBox2">
            <div class="imgBox2">
              <div class="avater-box">
                <img class="avater" :src="$store.state.userInfo.logo" alt="" />
                <div class="name">{{ $store.state.userInfo.nickname }}</div>
              </div>
              <img
                style="
                  width: auto;
                  margin-left: 8px;
                  height: 12px;
                  flex-grow: 0;
                "
                :src="VipInfo?.header?.new_tag_url"
                alt=""
              />
            </div>
            <div
              class="vip-card"
              @click="tableClick2('/vip')"
              :style="
                'background-image:url(' +
                `${VipInfo?.header?.web_info_back_url}` +
                ')'
              "
            >
              <div class="no-vip-box" v-if="VipInfo?.is_vip == 0">
                <div class="identity-title">
                  <img
                    class="identity"
                    :src="VipInfo?.header?.web_info_back_title_url"
                    alt=""
                  />
                  <div class="identity-time">{{ $t('home.vip') }}</div>
                </div>
                <div
                  class="identity-text"
                  v-html="
                    $utils.getSearchKeyword(
                      VipInfo?.header?.info,
                      VipInfo?.header?.info_show_num,
                      Brand
                    )
                  "
                ></div>
              </div>
              <div class="vip-box" v-if="VipInfo?.is_vip == 1">
                <div class="identity-title">
                  <img
                    class="identity"
                    :src="VipInfo?.header?.web_info_back_title_url"
                    alt=""
                  />
                  <div class="identity-time">{{ VipInfo?.header?.label }}</div>
                </div>
                <div
                  class="identity-text"
                  v-html="
                    $utils.getSearchKeyword(
                      VipInfo?.header?.info,
                      VipInfo?.header?.info_show_num,
                      Brand
                    )
                  "
                ></div>
                <div class="power-box">
                  <div class="power-item">
                    <img
                      class="icons"
                      :src="VipInfo?.header?.vip_benefits[0].icon"
                    />
                    <div class="box">
                      <div class="title">
                        {{ VipInfo?.header?.vip_benefits[0].title }}
                      </div>
                      <div class="info">
                        {{ VipInfo?.header?.vip_benefits[0].spec_label }}
                      </div>
                    </div>
                  </div>
                  <div class="power-item">
                    <img
                      class="icons"
                      :src="VipInfo?.header?.vip_benefits[1].icon"
                    />
                    <div class="box">
                      <div class="title">
                        {{ VipInfo?.header?.vip_benefits[1].title }}
                      </div>
                      <div class="info">
                        {{ VipInfo?.header?.vip_benefits[1].spec_label }}
                      </div>
                    </div>
                  </div>
                  <div class="power-item">
                    <img
                      class="icons"
                      :src="VipInfo?.header?.vip_benefits[2].icon"
                    />
                    <div class="box">
                      <div class="title">
                        {{ VipInfo?.header?.vip_benefits[2].title }}
                      </div>
                      <div class="info">
                        {{ VipInfo?.header?.vip_benefits[2].spec_label }}
                      </div>
                    </div>
                  </div>
                  <div class="power-item">
                    <img
                      class="icons"
                      :src="VipInfo?.header?.vip_benefits[3].icon"
                    />
                    <div class="box">
                      <div class="title">
                        {{ VipInfo?.header?.vip_benefits[3].title }}
                      </div>
                      <div class="info">
                        {{ VipInfo?.header?.vip_benefits[3].spec_label }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="space-box">
              <div class="title-box">
                <el-tooltip
                  v-if="VipInfo?.cloud_size?.is_rate_flow == 1"
                  placement="bottom-start"
                >
                  <template #content>
                    <div class="tooltip-Spacelevel">
                      <div
                        class="tooltip-item"
                        v-for="(item, index) in VipInfo?.cloud_size
                          ?.cloud_size_text"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template>
                  <div class="Space-title">
                    {{ $t('home.Cloudcapacity')
                    }}<svg-btn
                      class="Spacelevel"
                      icon-class="icon-Spacelevel"
                    ></svg-btn>
                  </div>
                </el-tooltip>
                <div v-else class="Space-title">
                  {{ $t('home.Cloudcapacity') }}
                </div>
                <div class="Space-size">
                  {{ VipInfo?.cloud_size?.self_size }}G /
                  <span
                    style="margin-left: 2px"
                    :class="{
                      endless: VipInfo?.cloud_size?.cloud_size == '999999',
                    }"
                  >
                    {{
                      VipInfo?.cloud_size?.cloud_size == '999999'
                        ? '∞'
                        : VipInfo?.cloud_size?.cloud_size + 'G'
                    }}</span
                  >
                </div>
              </div>
              <el-progress
                :percentage="usedPre > 100 ? 100 : usedPre"
                :stroke-width="4"
                :text-inside="true"
              ></el-progress>
            </div>
            <div class="Memberdata">
              <div class="data-item">
                <div class="item-title">
                  {{ VipInfo?.consume?.day_down_count }}
                </div>
                <div class="item-text">{{ $t('home.DownloadLimit') }}</div>
              </div>
              <div class="data-item">
                <div class="item-title">{{ VipInfo?.consume?.point }}</div>
                <div class="item-text">{{ $t('home.awelfarepoint') }}</div>
              </div>
              <div class="data-item">
                <div class="item-title">
                  {{ VipInfo?.consume?.down_speed_text }}
                </div>
                <div class="item-text">{{ $t('home.Downloadspeed') }}</div>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn-text" @click="tableClick2('/help')">
                {{ $t('home.HelpCentre') }}
              </div>
              <div class="ling"></div>
              <div class="btn-text" @click="tableClick2('/account')">
                {{ $t('home.AccountSettings') }}
              </div>
              <div class="ling"></div>
              <div class="btn-text" @click="loginOut()">
                {{ $t('home.SignOut') }}
              </div>
            </div>
          </div>
        </HoverPop>
      </div>
      <div class="loginbtn" v-else>
        <div v-show="$store.state.isLogin == 0">
          <HoverPop>
            <div class="notBox">
              <!-- <div
                class="notLoginBox"
                @click="openVip()"
                :style="{
                  backgroundImage: `url(${$utils.getPng(noBg)})`,
                }"
              >
                <div class="left">
                  <img
                    class="logoOpen"
                    :src="$utils.getPng('icon-vip-newTb-new')"
                  />
                  <span class="fontOne">{{
                    upgrade_type === 0
                      ? $t('home.Premium')
                      : upgrade_type === 1
                      ? $t('home.PremiumTwo')
                      : $t('home.PremiumThree')
                  }}</span>
                </div>
              </div> -->
            </div>
            <div
              slot="content"
              class="vipHoverBox3"
              :class="upgrade_type === 2 ? 'vipHoverBox4' : ''"
              @click="openVip()"
            >
              <img
                :class="upgrade_type === 2 ? 'topBoxVip2' : 'topBoxVip'"
                :src="
                  upgrade_type === 0
                    ? $utils.getPng('icon-vip-bgTwo-new')
                    : upgrade_type === 1
                    ? $utils.getPng('icon-vip-bgOne-new')
                    : $utils.getPng('icon-vip-bgThree-new')
                "
              />
              <div class="btBoxVip">
                <div class="fontLine">
                  开通后立享&nbsp;<span class="numLine">10+</span>&nbsp;会员特权
                </div>
                <div class="qlVipBox" v-if="this.upgrade_info.length > 0">
                  <div
                    class="qlBox"
                    v-for="(item, index) in upgrade_info"
                    :key="index"
                  >
                    <img class="qlIcon" :src="item.icons" alt="" />
                    <div class="qlRight">
                      <span class="titVip">{{ item.title }}</span>
                      <span class="textVip">{{ item.text }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="btNew"
                  v-if="upgrade_type !== 2"
                  @click="openVip()"
                  :style="{
                    backgroundImage: `url(${$utils.getPng(
                      'icon-vip-btNew-new'
                    )})`,
                  }"
                >
                  <span
                    >{{ upgrade_type == 0 ? '开通' : '升级'
                    }}{{ upgrade_obj?.title }}</span
                  >
                </div>
              </div>
            </div>
          </HoverPop>
        </div>
        <fm-button
          type="primary"
          round
          size="medium"
          style="margin: 0 16px 0 24px"
          @click="toLogin(1)"
          >{{ $t('home.Login') }}</fm-button
        >
        <fm-button type="info" round size="medium" @click="toLogin(2)">{{
          $t('home.Signup')
        }}</fm-button>
      </div>
    </div>
    <ChangePassword
      type="0"
      :isShow="changePassFlag"
      @handleClose="changePassFlag = false"
    />

    <BindPhone
      key="navTopBind"
      :isShow="isShowBindPhone"
      :type="bindType"
      :time="time"
      ref="bindPhoneCom"
      @getPhoneCode="getPhoneCode"
      @bindPhone="bindPhone"
      @confirmNameAuth="realNameAuth"
      @handleClose="isShowBindPhone = false"
    ></BindPhone>
  </div>
</template>

<script>
import {
  getUserInfoAPI,
  getWebUserVipInfoAPI,
  getPrivilege,
  userMsginfoapi,
  bindPhoneAPI,
  bindPhoneSendCode,
  realNameAuth,
  checkLoginAPI,
} from '@/axios/home'
import { loginOutAPI } from '@/axios/login'
import RaceNotice from '@/components/RaceNotice/index.vue'
import ChangePassword from '@/components/ChangePassword/index.vue'
import HoverPop from '@/components/hoverPop/index.vue'
import BindPhone from '@/components/Cloud/BindPhone'
import userNews from '@/components/userNews/index.vue'
export default {
  data() {
    return {
      msgid: '',
      timerA: null,
      time: 60,
      bindType: 1,
      isShowBindPhone: false,
      table: [
        {
          icon: 1,
          tit: '开通会员',
          path: '/vip',
        },
        // {
        //   icon: 4,
        //   tit: "我的订阅",
        //   path: "/home",
        // },
        {
          icon: 2,
          tit: '帮助',
          path: '/help',
        },
        {
          icon: 3,
          tit: '设置',
          path: '/account',
        },
      ],
      vipAdvTitle: '',
      vipList: [
        {
          id: 0,
          icon: this.$utils.getPng('web4/icon-t3'),
          text: '每天免排队、不限速下载300次',
        },
        {
          id: 1,
          icon: this.$utils.getPng('web4/icon-t1'),
          text: '送1000G云空间 + 500福利点',
        },
        {
          id: 1,
          icon: this.$utils.getPng('web4/icon-t4'),
          text: '尊享不限时长使用飞猫盘特权功能',
        },
      ],
      fuliList: [
        {
          id: 0,
          imgSrc: this.$utils.getPng('web4/icon-t2'),
          name: '免费下载文件',
        },
        {
          id: 1,
          imgSrc: this.$utils.getPng('web4/icon-t4'),
          name: '兑换会员特权',
        },
      ],
      changePassFlag: false,
      phone_item: {
        phone: '',
        pcode: '',
        sms_type: 0,
      },
      VipInfo: {},
      usedPre: 0,
      Brand: '',
      showDropItem: false,
      upgrade_type: 0,
      upgrade_info: [],
      upgrade_obj: {},
    }
  },
  computed: {
    rebate_model() {
      return localStorage.getItem('rebate_model')
    },
    haveBg() {
      return 'icon-vip-newBg-new'
    },
    noBg() {
      return 'icon-vip-noLogin-new'
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable)
    this.$store.commit('setAttr', {
      name: 'getusercallback',
      val: this.getUserInfo,
    })
    this.$store.commit('setAttr', {
      name: 'clearCookieCallback',
      val: this.clearCookie,
    })
    if (this.$store.state.isLogin == 1) {
      this.fetchData()
    }
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  methods: {
    //去主站短链页面
    toShort() {
      window.open(this.$glb.feemooUrl + '/shortChain', '_href')
    },
    fetchData() {
      this.getUserInfo()
      this.getWebUserVipInfoFn()
      this.userMsginfoapiFn()
      this.getPrivilegeInfo()
    },
    getPrivilegeInfo() {
      getPrivilege()
        .then(res => {
          if (res.status == 1) {
            this.upgrade_type = Number(res.data.upgrade_type)
            this.upgrade_info = res.data.upgrade_info
            this.upgrade_obj = res.data
          }
        })
        .catch(error => {})
    },
    showDropFun: _.debounce(
      function () {
        this.showDropItem = !this.showDropItem
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    changeLang(lang) {
      this.$i18n.setLocaleAndSave(this.$route, lang)
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'prerender':
          // console.log("网页预渲染，内容不可见");
          break
        case 'hidden':
          // console.log("内容不可见，处理后台、最小化、锁屏状态");
          break
        case 'visible':
          // console.log('页面可见')
          let isLogin = localStorage.getItem('shortLogin')
          if (isLogin && isLogin == 1) {
            //缓存提示登录了,但是vuex没更新的情况
            if (this.$store.state.isLogin == 0) {
              this.fetchData()
            }
            this.checkLogin()
          } else {
            if (this.$store.state.isLogin == 1) {
              this.loginOut()
            }
          }
          // if (Number(localStorage.getItem('shortLogin')) !== 1) {
          //   this.fetchData()
          // }
          break
      }
    },
    handleOpenPhone(args) {
      const { type, show } = args
      this.bindType = type
      this.isShowBindPhone = show
    },
    userMsginfoapiFn() {
      userMsginfoapi()
        .then(res => {
          this.$store.commit('setAttr', {
            name: 'userMsgNub',
            val: +res.data.count || 0,
          })
        })
        .catch(err => {})
    },
    getWebUserVipInfoFn() {
      getWebUserVipInfoAPI()
        .then(res => {
          if (res.status == 1) {
            this.VipInfo = res.data
            document.documentElement.style.setProperty(
              '--Brand-1',
              ['#5F646F', '#915D44', '#374A71', '#764A0B', '#503567'][
                res.data.header.new_user_head
              ]
            ) // 浅色白底悬浮
            document.documentElement.style.setProperty(
              '--Brand-2',
              [
                'rgba(95, 100, 111, .6)',
                'rgba(145, 93, 68, .6)',
                'rgba(55, 74, 113, .6)',
                'rgba(118, 74, 11, .6)',
                'rgba(80, 53, 103, .6)',
              ][res.data.header.new_user_head]
            ) // 浅色白底悬浮
            this.Brand = [
              '#5F646F',
              '#915D44',
              '#374A71',
              '#764A0B',
              '#503567',
            ][res.data.header.new_user_head]
            if (res.data.cloud_size.cloud_size == '999999') {
              this.usedPre = 0
            } else {
              this.usedPre =
                (res.data.cloud_size.self_size /
                  res.data.cloud_size.cloud_size) *
                100
            }
          }
        })
        .catch(err => {})
    },
    getUserInfo() {
      getUserInfoAPI()
        .then(res => {
          // console.log('getUserInfoAPI', res)
          if (res.status == 1) {
            this.$store.commit('setAttr', {
              name: 'userInfo',
              val: res.data,
            })
            this.$store.commit('setAttr', {
              name: 'isLogin',
              val: 1,
            })
            localStorage.setItem('shortLogin', 1)
          }
        })
        .catch(err => {})
    },
    checkLogin() {
      checkLoginAPI()
        .then(res => {})
        .catch(err => {})
    },
    toLogin(num) {
      const lang = {
        en: '/en-US',
        hk: '/zh-HK',
        zh: '',
      }
      const from = 'short'
      const fromUrl = window.location.origin + this.$route.path
      const fshort = sessionStorage.getItem('shortFshort')
      const encodedFrom = encodeURIComponent(from)
      const encodedFromUrl = encodeURIComponent(fromUrl)
      let url = `${this.$glb.feemooUrl}${
        lang[this.$store.state.language]
      }/login?path=drive&from=${encodedFrom}&fromUrl=${encodedFromUrl}&is_recommend_expand=${fshort}`
      //注册
      if (num == 2) {
        url = url + '&tab=2'
      }
      this.$store.commit('setShowLoginShort', url)
      this.$store.commit('setShowLogin', true)
    },
    tableClick2(item) {
      let url = this.$glb.feemooUrl + item
      window.open(url, '_blank')
    },
    loginOut() {
      loginOutAPI({ is_cross: 1 })
        .then(res => {
          if (res.status == 1) {
            localStorage.removeItem('platfro')
            localStorage.removeItem('shortToken')
            localStorage.removeItem('shortLogin')
            this.$utils.clearCookie(this.$glb.fmCookieName)
            this.$store.commit('clearUserData') //重置缓存
            window.location.reload()
          }
        })
        .catch(err => {})
    },
    handleClickPsw() {
      this.changePassFlag = true
    },
    clearCookie() {
      this.$utils.clearCookie(this.$glb.fmCookieName)
    },
    openVip() {
      let url = this.$glb.feemooUrl + '/vip'
      window.open(url, '_blank')
    },
    minute() {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        clearInterval(this.timerA)
      }
    },
    getPhoneAly(captcha_verify, validate = {}) {
      return new Promise(resolve => {
        if (validate == 'close') {
          return
        }
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          sms_type: this.phone_item.sms_type,
          captcha_verify: captcha_verify || '',
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
        }).then(res => {
          if (res.status == '1') {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 1)
            this.msgid = res.data.msgid
            this.bindType = 3
            this.timerA = setInterval(() => {
              this.minute()
              this.$refs.bindPhoneCom?.onFocus()
            }, 1000)
          } else if (res.status == 90001) {
            resolve({
              result: false,
              validate: false,
            })
            this.$toast(res.msg, 2)
            this.$AliCode.handleOpen(this.getPhoneAly)
          } else if (res.status == 90002) {
            this.$utils.initgt4(
              '5b0562a75492b420626b745b229e83a4',
              this.getPhoneAly
            )
          } else {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 2)
          }
        })
      })
    },
    getPhoneCode(phone, pcode, sms_type) {
      this.phone_item = {
        phone,
        pcode,
        sms_type,
      }
      // var reg_tel =
      //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // if (!reg_tel.test(phone)) {
      //   this.$toast("请正确输入手机号", 3);
      //   return true;
      // }
      this.getPhoneAly()
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data }
      bindPhoneAPI(params).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)

          if (this.$store.state.bindPhoneCallback) {
            this.$store.state.bindPhoneCallback()
          }
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    realNameAuth(data) {
      realNameAuth(data).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    goLogin() {
      let path = this.$route.fullPath.toString().slice(1)
      this.$router.push({ path: '/login', query: { path: path } })
      return
    },
  },
  components: {
    RaceNotice,
    ChangePassword,
    HoverPop,
    BindPhone,
    userNews,
  },
}
</script>

<style lang="scss" scoped>
::v-deep .fontLine {
  span {
    margin: 0 2px;
  }
}
@import './index.scss';
</style>
